import { lazyRouteComponent } from '@tanstack/react-router';

export const billingPageLoadable = lazyRouteComponent(() =>
  import('../../ui/billing-page').then((m) => ({ default: m.BillingPage })),
);
